import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // API基础URL（根据环境变量配置）
  timeout: 10000, // 请求超时时间
})

let authRedirecting = false

function redirectToLogin(message) {
  if (authRedirecting) return
  authRedirecting = true
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  Message({
    message: message || '登录过期，请重新登录',
    type: 'warning'
  })
  window.location.href = '/login'
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // FormData 上传时由浏览器自动带 multipart boundary，勿强制 json
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // Excel 等文件下载直接返回完整 response，供 headers / blob 使用
    if (response.config.responseType === 'blob') {
      return response
    }

    const res = response.data
    
    if (res.code !== 0) {
      if (res.code === 401) {
        redirectToLogin(res.message)
      } else if (res.code === 403) {
        console.error('权限不足')
      }
      
      return Promise.reject(new Error(res.message || '服务器错误'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误:', error)
    
    let errorMessage = error.message || '请求失败'
    
    if (error.response) {
      const { status, data } = error.response
      
      // 尝试从响应数据中提取错误信息
      if (data && data.message) {
        errorMessage = data.message
      }
      
      if (status === 401) {
        redirectToLogin(data && data.message)
        return Promise.reject(new Error(errorMessage || '登录过期，请重新登录'))
      } else if (status === 403) {
        errorMessage = '权限不足'
      } else if (status === 404) {
        errorMessage = '请求地址不存在'
      } else if (status >= 500) {
        errorMessage = data?.message || '服务器内部错误'
      }
    } else if (error.request) {
      errorMessage = '网络错误，请检查网络连接'
    }
    
    // 创建一个包含自定义错误信息的Error对象
    const customError = new Error(errorMessage)
    // 保留原始错误信息
    customError.originalError = error
    // 保留响应数据
    if (error.response?.data) {
      customError.responseData = error.response.data
    }
    
    return Promise.reject(customError)
  }
)

export default service
